import { useState } from "react";

export function NavBar({ setter }) {
  const [btn, set] = useState(["btn-clicked", "btn", "btn", "btn"]);
  function handle(y) {
    set((x) => x.map((i, j) => (j == y ? "btn-clicked" : "btn")));
    setter(y);
  }
  return (
    <div className="nav">
      <button
        value="0"
        className={btn[0]}
        onClick={(e) => handle(e.target.value)}
      >
        About
      </button>
      <button
        value="1"
        className={btn[1]}
        onClick={(e) => handle(e.target.value)}
      >
        Resume
      </button>
      <button
        value="2"
        className={btn[2]}
        onClick={(e) => handle(e.target.value)}
      >
        Projects
      </button>
      <button
        value="3"
        className={btn[3]}
        onClick={(e) => handle(e.target.value)}
      >
        Contact
      </button>
    </div>
  );
}
